import React, { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';

const VideoCallRequestBadge = ({ storeId }) => {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    if (!storeId) {
      console.warn('⚠️ VideoCallRequestBadge: No storeId');
      return;
    }

    console.log('🔍 VideoCallRequestBadge: Subscribing to pending requests for storeId:', storeId);

    // Subscribe to real-time updates for pending requests
    const requestsRef = collection(db, 'videoCallRequests');
    const q = query(
      requestsRef,
      where('storeId', '==', storeId),
      where('status', '==', 'pending')
    );

    const unsubscribe = onSnapshot(q, 
      (snapshot) => {
        console.log('📊 VideoCallRequestBadge: Found', snapshot.size, 'pending requests');
        setPendingCount(snapshot.size);
      }, 
      (error) => {
        console.error('❌ Error listening to video call requests:', error);
        if (error.code === 'failed-precondition') {
          console.warn('⚠️ Firestore index may be missing. Please create index for: videoCallRequests (storeId, status)');
        }
      }
    );

    return () => {
      console.log('🧹 VideoCallRequestBadge: Cleaning up subscription');
      unsubscribe();
    };
  }, [storeId]);

  if (pendingCount === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
      {pendingCount > 9 ? '9+' : pendingCount}
    </span>
  );
};

export default VideoCallRequestBadge;

